import axios from 'axios';
import Global from './Global';
import {getData, removeData, storeData} from './StorageUtil';
import Cookies from "js-cookie"

import FingerprintJS from '@fingerprintjs/fingerprintjs'
import {QC_INSPECTOR} from "../Variable";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";

const fpPromise = FingerprintJS.load()

const kitchen = axios.create({
    baseURL:Global.BASE_URL,
    timeout:1000*60*60,
    maxContentLength: 9999999999999999999999,
    maxBodyLength: 9999999999999999999999
})

kitchen.interceptors.request.use(async function (config) {
    if(Global.DEBUG){
        console.log({"request":config})
    }
    let authorization = getData(Global.AUTHORIZATION)
    if(authorization){
        config.headers['Authorization'] = authorization;
    }else{
        let headers = config.headers
        config.headers = {}
        if(headers['grt']){
            config.headers['grt'] = headers['grt']
        }
    }

    let visitorId = Cookies.get('visitorId');
    if(!visitorId){ // Tidak ada cookie? remove cookie dan generate baru
        Cookies.remove("visitorId");

        const fp = await fpPromise
        const result = await fp.get()
        visitorId = result.visitorId
        Cookies.set("visitorId", visitorId, { expires: 365 })
    }
    config.headers['DeviceId'] = visitorId;

    config.headers['Platform'] = QC_INSPECTOR;
    let key = getData(Global.LANGUAGE);
    if(isEmpty(key)){
        key = Global.DEFAULT_LANGUAGE
    }

    config.headers['Accept-Language'] = key;
    return config;
}, function (error) {
    return Promise.reject(error);
});

kitchen.interceptors.response.use(function (response) {
    if(Global.DEBUG){
        console.log({"response":response})
    }
    if(response.headers && response.headers.authorization){
        if(response.headers.authorization!=''){
            storeData(Global.AUTHORIZATION, response.headers.authorization)
        }else{
            removeData(Global.AUTHORIZATION)
        }
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default kitchen
